import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/email',
	exact: true,
};
